import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  public combineUri(...uris: Array<string | undefined>): string {
    return uris.filter(Boolean).join('/');
  }
}
